import script from "./TextField.vue?vue&type=script&setup=true&lang=js"
export * from "./TextField.vue?vue&type=script&setup=true&lang=js"

import "./TextField.vue?vue&type=style&index=0&id=059ce0e4&lang=scss"
/* custom blocks */
import block0 from "./TextField.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__